import React from 'react';
import { Home, Waves, Droplets, Sun, Building2, Truck, Trash2, Zap } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './Card';
const SERVICES = [{
  title: 'Home Improvements',
  description: 'From carpentry to general repairs, we handle all your home improvement needs with expert craftsmanship.',
  icon: Home
}, {
  title: 'Plumbing Services',
  description: 'Comprehensive plumbing solutions including leak repairs, fixture installations, and drain cleaning.',
  icon: Droplets
}, {
  title: 'Well Pump Services',
  description: 'Specialized well pump installation, maintenance, and repair to keep your water flowing reliably.',
  icon: Waves
}];
export function Services() {
  return <section id="services" className="py-24 bg-slate-50 relative overflow-hidden" data-id="element-214">
      <div className="absolute top-0 right-0 opacity-5 pointer-events-none transform translate-x-1/3 -translate-y-1/3" data-id="element-215">
        <svg width="600" height="600" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-216">
          <path fill="#1d3a63" d="M45.7,-76.4C58.9,-69.3,69.1,-55.3,77.5,-40.5C85.9,-25.7,92.5,-10.1,90.4,4.6C88.3,19.3,77.5,33.1,65.8,44.3C54.1,55.5,41.5,64.1,27.3,70.5C13.1,76.9,-2.7,81.1,-18.2,78.9C-33.7,76.7,-48.9,68.1,-60.8,56.1C-72.7,44.1,-81.3,28.7,-84.5,12.3C-87.7,-4.1,-85.5,-21.5,-77.3,-36.1C-69.1,-50.7,-54.9,-62.5,-40.1,-68.9C-25.3,-75.3,-9.9,-76.3,6.3,-84.1C22.5,-91.9,32.5,-83.5,45.7,-76.4Z" transform="translate(100 100)" data-id="element-217" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-218">
        <div className="flex flex-col lg:flex-row gap-12 mb-16 items-center" data-id="element-219">
          <div className="lg:w-1/2 text-left" data-id="element-220">
            <h2 className="font-display text-4xl md:text-5xl text-slate-900 uppercase tracking-wide mb-4" data-id="element-221">
              Expert Repairs for <span className="text-accent" data-id="element-222">Every Need</span>
            </h2>
            <p className="text-slate-600 text-lg" data-id="element-223">
              From leaky faucets to carpentry and well pumps, we have the
              expertise and tools for the job. We treat your home with respect
              and leave your property looking and working beautifully.
            </p>
          </div>
          <div className="lg:w-1/2" data-id="element-224">
            <img src="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?q=80&w=1200&auto=format&fit=crop" alt="Modern residential kitchen sink and faucet fixture" className="rounded-2xl shadow-2xl border-2 border-slate-200 w-full h-auto object-cover max-h-[400px]" data-id="element-225" />
          </div>
        </div>

        <div data-id="element-226">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center gap-3 border-b border-slate-200 pb-4" data-id="element-227">
            <Home className="h-6 w-6 text-accent" data-id="element-228" />
            Our Specialties
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-229">
            {SERVICES.map((service, idx) => <ServiceCard key={idx} {...service} data-id="element-230" />)}
          </div>
        </div>
      </div>
    </section>;
}
function ServiceCard({
  title,
  description,
  icon: Icon
}: {
  title: string;
  description: string;
  icon: any;
}) {
  return <Card className="bg-white border-slate-200 hover:border-accent/60 transition-all duration-300 group hover:shadow-[0_0_30px_rgba(29,58,99,0.15)] relative overflow-hidden" data-id="element-231">
      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-232">
        <Zap className="h-5 w-5 text-accent/50" data-id="element-233" />
      </div>
      <CardHeader data-id="element-234">
        <div className="h-12 w-12 rounded-lg bg-slate-50 border border-slate-200 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-235">
          <Icon className="h-6 w-6 text-accent" data-id="element-236" />
        </div>
        <CardTitle className="text-xl text-slate-900" data-id="element-237">{title}</CardTitle>
      </CardHeader>
      <CardContent data-id="element-238">
        <CardDescription className="text-slate-600 text-base mb-6" data-id="element-239">
          {description}
        </CardDescription>
        <a href="#contact" className="text-accent font-bold uppercase tracking-wider text-sm hover:text-accent-light transition-colors inline-flex items-center gap-2" data-id="element-240">
          Get Quote
          <span className="group-hover:translate-x-1 transition-transform" data-id="element-241">
            →
          </span>
        </a>
      </CardContent>
    </Card>;
}